const password = {
    unsupported_encryption_method: 'O método de encriptação {{name}} não é suportado.',
    pepper_not_found: 'pepper da Password não encontrada. Por favor, verifique os envs.',
    rejected: 'Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos.',
};
export default Object.freeze(password);
